// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a6074242","453":"c1d2e79a","732":"026aad4b"}[chunkId] + ".chunk.js";
};